import * as Yup from 'yup';
import moment from 'moment';

const parseFormats = ['MMM dd, yyy'];
const invalidDate = new Date('');

export const momentDateSchemaType = Yup.date().transform(function yupDateSchemaMomentTransform(value, originalValue) {
  if (this.isType(value)) return value;

  // the default coercion transform failed so let's try it with Moment instead
  const transformedValue = moment(originalValue, parseFormats);
  return transformedValue.isValid() ? transformedValue.toDate() : invalidDate;
});
